import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import {baseUrl, issueStatusList, requirementStatusList,orderStatusList,purchaseStatusList,returnReceiptStatusList,receiptStatusList, addDays } from "../../comman/config";
import { menuAboveTable } from "../../comman/selectMenu";

const MainRequirementFilter = ({ handleFilterChange, page, handleClearFilters }) => {
    const today = new Date().toISOString().split('T')[0];
    const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(addDays(new Date(), 1).toISOString().split('T')[0]);
    const [session, setSession] = useState("");
    
    const [requirementStatus, setRequirementStatus] = useState(requirementStatusList[1]);
    const [orderStatus, setOrderStatus] = useState(orderStatusList[1]);
    const [purchaseStatus, setPurchaseStatus] = useState(purchaseStatusList[1]);
    const [receiptStatus, setReceiptStatus] = useState([returnReceiptStatusList[1],returnReceiptStatusList[2]]);
    const [issueStatus, setIssueStatus] = useState([issueStatusList[1],issueStatusList[2]])
    const [mainReceiptStatus, setMainReceiptStatus] = useState(receiptStatusList[0]);
    const [orderId, setOrderId] = useState("");
    const [ingredientList, setIngredientList] = useState([]);
    const [filter, setFilter] = useState(false);
    const [sessionList, setSessionList] = useState([]);
    const [orderIdList, setOrderIdList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [item, setItem] = useState([]);
    const [ingredient, setIngredient] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [category, setCategory] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [event, setEvent] = useState({});
    const [autoSetToDate, setAutoSetToDate] = useState(true);

    useEffect(() => {
        getSessionList();
        getItemList();
        getIngredientList();
        getOrderIdList();
        getIngredientCategories();
        getEventList();
    }, []);

    const getSessionList =  async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=session_master&condition=status=1`,
            { headers: { 'Cache-Control': 'no-cache' } }
        );
        const sessionListWithAll = [{ id: 'all', name: 'All' }, ...response.data.data];
        setSessionList(sessionListWithAll);
        // setSessionList(response.data.data);
        setSession({ value: 'all', label: 'All' });
    }

    const getItemList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_master&condition=status=1`);
        const itemList = response.data.data;
        const itemListWithAll = [{ id: 'all', item_name: 'All' }, ...itemList];
        setItemList(itemListWithAll);
        // setItemList(itemList);
        setItem({ value: 'all', label: 'All' });
    }

    const getIngredientList = async () => {
        const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
        const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 1);
        // setIngredientList(list);
        const ingredientListWithAll = [{ id: 'all', ingredient: 'All' }, ...list];
        setIngredientList(ingredientListWithAll);
        setIngredient({ value: 'all', label: 'All' });
    };

    const getIngredientCategories = async () => {
        const response = await axios.get(`${baseUrl}/ingredients/category/list?condition=status=1`);
        const list = response.data.data;
        setCategoryList(list);
    };

    const getOrderIdList =  async () => {
        const condition = `order_id IS NOT NULL GROUP BY order_id`;
        const response = await axios.get(`${baseUrl}/comman/list?table=item_requirement_summary&condition=${condition}`,
            { headers: { 'Cache-Control': 'no-cache' } }
        );
        setOrderIdList(response.data.data);
    }
    const handleDateChange = (e) => {
        const {name, value} = e.target;
        if(name == "from_date"){
            setFromDate(value);
            if (page === "receipt" && autoSetToDate) {
                setToDate(value); // Set to date to the same value as from date
            }

            // Update "to_date" if it is before the new "from_date"
            if (new Date(toDate) < new Date(value)) {
                setToDate(value); // Match "to_date" to "from_date"
            }

        }else if(name == "to_date"){
            setToDate(value);
            setAutoSetToDate(false);
        }
    };

    const getEventList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=event_master&condition=status=1`);
        const data = response.data.data;
        setEventList(data);
        setEvent({ value: 'all', label: 'All' });
    }

    
    const handleSelectChange = (data, option) => {
        if(option.name == 'session'){
            setSession(data);
        }else if(option.name == 'requirement_status'){
            setRequirementStatus(data);
        }else if(option.name == 'order_status'){
            setOrderStatus(data);
        }else if(option.name == 'order_id'){
            setOrderId(data);
        }else if(option.name == 'purchase_status'){
            setPurchaseStatus(data);
        }else if(option.name == 'receipt_status'){
            setReceiptStatus(data);
        }else if(option.name == 'issue_status'){
            setIssueStatus(data)
        }else if(option.name === 'category'){
            setCategory(data)
        }else if(option.name === 'main_receipt_status'){
            setMainReceiptStatus(data)
        }
        
    };
    const handleChangeMultiSelect = (selected, name) => {
        if(name === 'item'){
            setItem(selected);
        }else if(name === "ingredient"){
            setIngredient(selected);
        }
        
    };

    const handelEventChange = (selectedEvent) => {
        const data = eventList.filter(i => i.id == selectedEvent.value);
        setEvent({value: data[0].id, label: data[0].event_name});
        
            // For specific events, use that event's dates
            setFromDate(data[0].start_date);
            setToDate(data[0].end_date);
            setIngredient({ value: 'all', label: 'All' });
            setSession({ value: 'all', label: 'All' });
            handleFilterChange(
                data[0].start_date, 
                data[0].end_date, 
                { value: 'all', label: 'All' }, 
                { value: 'all', label: 'All' }, 
                {value: data[0].id, label: data[0].event_name}, 
                true
            );
        
        
        setFilter(true);
    };

    const handleSubmit = () => {
        if(page == "issue"){
            handleFilterChange(fromDate, toDate, session, item, issueStatus);
        }
        if(page == "receipt"){
            handleFilterChange(fromDate, toDate, session, item, receiptStatus);
        }
        if(page == "main_receipt"){
            handleFilterChange(fromDate, toDate, ingredient, category, mainReceiptStatus);
        }
        if(page == "inventory_report"){
            handleFilterChange(fromDate, toDate, ingredient,session);
        }
        setFilter(true);
    };

    const handleClear = () => {
        // Clear takes the inline per-column filters with it. Leaving them set would look like
        // Clear had emptied the report, when a column filter is still hiding the rows.
        handleClearFilters?.();
        setSession({ value: 'all', label: 'All' });
        setFromDate(today);
        setToDate(today);
        setItem({ value: 'all', label: 'All' });
        setRequirementStatus(requirementStatusList[1]);
        setOrderStatus(orderStatusList[1]);
        setPurchaseStatus(purchaseStatusList[1]);
        setReceiptStatus([returnReceiptStatusList[1],returnReceiptStatusList[2]]);
        setIssueStatus([issueStatusList[1],issueStatusList[2]])
        setCategory([]);
        setMainReceiptStatus(receiptStatusList[0]);
        setOrderId("");
        setIngredient({ value: 'all', label: 'All' });
        setEvent({ value: 'all', label: 'All' })
        if(page == "issue"){
            handleFilterChange(today, today, { value: 'all', label: 'All' }, { value: 'all', label: 'All' },[issueStatusList[1],issueStatusList[2]]);
        }
        if(page == "receipt"){
            handleFilterChange(today, today, { value: 'all', label: 'All' }, { value: 'all', label: 'All' }, [returnReceiptStatusList[1],returnReceiptStatusList[2]]);
        }
        if(page == "main_receipt"){
            handleFilterChange(today, today, "", "", [receiptStatusList[0]]);
        }
        if(page == "inventory_report"){
            handleFilterChange(today, today, { value: 'all', label: 'All' }, { value: 'all', label: 'All' });
        }
        setFilter(false);
    }

    return (
        <div className="pb-4 flex flex-column max-sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center">
            {page == "inventory_report" &&
            <>
            <div className='m-5'>
                <Select
                    {...menuAboveTable}
                    classNamePrefix="select"
                    className='basic-single w-48'
                    value={event}
                    name="event_name"
                    onChange={(selectedOptions) => handelEventChange(selectedOptions)}
                    options={eventList.map(item => ({
                        value: item.id,
                        label: item.event_name
                    }))}
                    placeholder="Event List"
                    filterOption={(option, inputValue) => {
                        return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                    }}
                />
            </div>
            </>}

            {(page == "issue" || page == "receipt" || page == "inventory_report") && 
            <>
            <div className='m-5 max-sm:m-1'>
                <input
                    type="date"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="from_date"
                    onChange={handleDateChange}
                    value={fromDate}
                />
            </div>
            <div className='m-5 max-sm:m-1'>
                <input
                    type="date"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="to_date"
                    onChange={handleDateChange}
                    min={fromDate}
                    value={toDate}
                />
            </div>
            </>
}
            {page == "issue" && 
            <>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={session}
                        name="session"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={sessionList.map(item => ({
                            value: item.id,
                            label: item.name
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        // isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={item}
                        name="item"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'item')}
                        options={itemList.map(item => ({
                            value: item.id,
                            label: `${item.item_name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                        }))}
                        placeholder="Item List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>

                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        value={issueStatus}
                        name="issue_status"
                        onChange={(selectedOption, name) => {
                            console.log(selectedOption)
                            handleSelectChange(selectedOption, name);
                        }}
                        options={issueStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            </>}

            {page == "main_receipt" && 
            <>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={ingredient}
                        name="ingredient"
                        onChange={(selectedOption) => {
                            handleChangeMultiSelect(selectedOption, 'ingredient');
                        }}
                        options={ingredientList.map(item => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            eng_name: item.eng_name,
                        }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        // isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={category}
                        name="category"
                        onChange={(selectedOptions, name) => handleSelectChange(selectedOptions, name)}
                        options={categoryList.map(item => ({
                            value: item.id,
                            label: `${item.name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                        }))}
                        placeholder="Select"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>

                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        //isMulti
                        classNamePrefix="select"
                        value={mainReceiptStatus}
                        name="main_receipt_status"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={receiptStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            </>}

            {page == "receipt" && 
            <>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        value={session}
                        name="session"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={sessionList.map(item => ({
                            value: item.id,
                            label: item.name
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        // isMulti
                        classNamePrefix="select"
                        className='basic-multi-select'
                        value={item}
                        name="item"
                        onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'item')}
                        options={itemList.map(item => ({
                            value: item.id,
                            label: `${item.item_name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                        }))}
                        placeholder="Item List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>

                <div className='m-5'>
                    <Select
                        {...menuAboveTable}
                        isMulti
                        classNamePrefix="select"
                        value={receiptStatus}
                        name="receipt_status"
                        onChange={(selectedOption, name) => {
                            console.log(selectedOption)
                            handleSelectChange(selectedOption, name);
                        }}
                        options={returnReceiptStatusList.map(item => ({
                            value: item.value,
                            label: item.label
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
            </>}
            {page == "inventory_report" && 
            <>
                <div className='m-5'>
               
                    {/* Wide enough for an ingredient's two names -- "ખાંડ (Sugar)" -- rather than
                        as narrow as the box happens to shrink to. */}
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        className='basic-single w-72'
                        value={ingredient}
                        name="ingredient"
                        onChange={(selectedOption) => {
                            handleChangeMultiSelect(selectedOption, 'ingredient');
                        }}
                        options={ingredientList.map(item => ({
                            value: item.id,
                            label: item.id === 'all' ? 'All' : `${item.ingredient} (${item.eng_name})`,
                            eng_name: item.eng_name,
                        }))}
                        placeholder="Ingredient List"
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                <div className='m-5'>
               
                    <Select
                        {...menuAboveTable}
                        classNamePrefix="select"
                        className='basic-single w-44'
                        value={session}
                        name="session"
                        onChange={(selectedOption, name) => {
                            handleSelectChange(selectedOption, name);
                        }}
                        options={sessionList.map(item => ({
                            value: item.id,
                            label: item.name
                        }))}
                        filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                    />  
                </div>
                </>}                

            <div className='m-5'>
                <button
                    onClick={handleSubmit}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                >
                    Submit
                </button>
                {filter && 
                 <button
                 onClick={handleClear}
                 className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
             >
                 Clear
             </button>}
            </div>
        </div>
    );
};

export {MainRequirementFilter};
